// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "img[data-v-3e438449]{position:absolute;top:0;bottom:0;left:0;right:0;width:100vw;height:100vh;display:block;-o-object-fit:contain;object-fit:contain;-o-object-position:center;object-position:center;opacity:0;-webkit-transition:opacity .5s;transition:opacity .5s}img.loaded[data-v-3e438449]{opacity:1}", ""]);
// Exports
module.exports = exports;
